import React from "react";
import { TouchableOpacity, Platform } from "react-native";
import { formatNumber } from "digiwash-core";

import Box from "../Box";
import Stack from "../Stack";
import Typography from "../Typography";
import { formatPrice } from "../helpers/number";
import Divider from "../Divider";
import { percentCalc } from "./ProductItem-helpers";

export interface ProductItemType {
  id: string | number;
  title: string;
  description?: string;
  total_price?: string | number;
  previous_price?: string | number;
  price_type?: string;
  // quantity: number;
  // price: number;
  // loading: boolean;
}

interface PropTypes {
  data: ProductItemType;
  onClick?: (data: ProductItemType) => void;
  children?: React.ReactNode;
  sub?: React.ReactNode;
  onLongPress?: () => void;
  link?: string;

  theme?: {
    main?: string;
  };
}

function ProductItem(props: PropTypes) {
  let mainColor = props?.theme?.main || "primary";
  let cardBg = `${mainColor}.light940`;
  let { data } = props;

  if (!data) {
    return null;
  }

  let hasTotalPrice =
    typeof data.total_price === "number" ||
    typeof data.total_price === "string";
  let hasPreviousPrice =
    typeof data.previous_price === "number" ||
    typeof data.previous_price === "string";

  return (
    <Stack>
      <TouchableOpacity
        style={{
          flexGrow: 1,
          flexShrink: 1,
        }}
        onPress={() => {
          if (props.onClick) {
            props.onClick(data);
          }
        }}
        onLongPress={props.onLongPress}
      >
        <TouchableOpacity
          onPress={() => {
            if (props.onClick) {
              props.onClick(data);
            }
            if (Platform.OS === "web" && props.link) {
              window.open(props.link, "_blank");
            }
          }}
        >
          <Box p="m" br="m" bg={cardBg}>
            <Stack distribution="space-between" alignment="center">
              <Box
                style={{
                  flexShrink: 1,
                }}
              >
                <Stack direction="vertical" alignment="end">
                  {hasPreviousPrice ? (
                    <Box bg="red.light" px="l" br="m">
                      <Typography fs="s" color="red.main">
                        {`${formatNumber(
                          /* @ts-ignore farzad will fix*/
                          percentCalc(data.previous_price, data.total_price)
                        )}٪ تخفیف`}
                      </Typography>
                    </Box>
                  ) : null}

                  <Typography
                    color="common.black"
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    {data.title}
                  </Typography>
                </Stack>
              </Box>

              <Stack>
                <Stack distribution="center" direction="vertical">
                  {hasPreviousPrice ? (
                    <Typography
                      fs="s"
                      color="red.main"
                      style={{
                        textDecorationLine: "line-through",
                        textDecorationStyle: "solid",
                      }}
                    >
                      {typeof data.previous_price === "number"
                        ? `${formatPrice(data.previous_price)} تومان`
                        : null}
                      {typeof data.previous_price === "string"
                        ? data.previous_price
                        : null}
                    </Typography>
                  ) : null}
                  {hasTotalPrice ? (
                    <Typography ff="mainBold" color={`${mainColor}.dark`}>
                      {typeof data.total_price === "number"
                        ? `${formatPrice(data.total_price)} تومان`
                        : null}
                      {typeof data.total_price === "string"
                        ? data.total_price
                        : null}
                    </Typography>
                  ) : null}
                </Stack>
                {!!props.sub ? props.sub : null}
              </Stack>
            </Stack>
            <Box>
              {data.description ? (
                <>
                  <Divider size="m" />
                  <Typography fs="s" color="neutrals.700" alignment="center">
                    {data.description}
                  </Typography>
                </>
              ) : null}
            </Box>
          </Box>
        </TouchableOpacity>
      </TouchableOpacity>
      {props.children}
    </Stack>
  );
}

export default ProductItem;
